import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H18C22.4183 0 26 3.58172 26 8V18C26 22.4183 22.4183 26 18 26H8C3.58172 26 0 22.4183 0 18V8Z"
      fill="#D33D3D"
    />
    <g clipPath="url(#clip0_235_16435)">
      <path
        d="M15.7187 10.2812C15.5913 10.1538 15.4184 10.0822 15.2382 10.0822C15.058 10.0822 14.8851 10.1538 14.7577 10.2812L13 12.0389L11.2423 10.2812C11.1141 10.1574 10.9424 10.0889 10.7642 10.0905C10.586 10.092 10.4155 10.1635 10.2895 10.2895C10.1635 10.4155 10.092 10.586 10.0905 10.7642C10.0889 10.9424 10.1574 11.1141 10.2812 11.2423L12.0389 13L10.2812 14.7577C10.1574 14.8859 10.0889 15.0575 10.0905 15.2358C10.092 15.414 10.1635 15.5844 10.2895 15.7105C10.4155 15.8365 10.586 15.908 10.7642 15.9095C10.9424 15.9111 11.1141 15.8426 11.2423 15.7187L13 13.9611L14.7577 15.7187C14.8859 15.8426 15.0575 15.9111 15.2358 15.9095C15.414 15.908 15.5844 15.8365 15.7105 15.7105C15.8365 15.5844 15.908 15.414 15.9095 15.2358C15.9111 15.0575 15.8426 14.8859 15.7187 14.7577L13.9611 13L15.7187 11.2423C15.8462 11.1149 15.9177 10.942 15.9177 10.7618C15.9177 10.5816 15.8462 10.4087 15.7187 10.2812Z"
        fill="white"
      />
      <path
        d="M13 4.84375C11.3868 4.84375 9.80992 5.32211 8.46863 6.21833C7.12734 7.11455 6.08194 8.38838 5.46461 9.87874C4.84728 11.3691 4.68576 13.009 5.00047 14.5912C5.31518 16.1734 6.09199 17.6267 7.23266 18.7673C8.37333 19.908 9.82664 20.6848 11.4088 20.9995C12.991 21.3142 14.6309 21.1527 16.1213 20.5354C17.6116 19.9181 18.8855 18.8727 19.7817 17.5314C20.6779 16.1901 21.1562 14.6132 21.1562 13C21.1539 10.8375 20.2938 8.76433 18.7648 7.23524C17.2357 5.70616 15.1625 4.84609 13 4.84375ZM13 19.7969C11.6557 19.7969 10.3416 19.3982 9.22386 18.6514C8.10612 17.9045 7.23495 16.843 6.72051 15.601C6.20607 14.3591 6.07147 12.9925 6.33373 11.674C6.59599 10.3555 7.24333 9.14444 8.19389 8.19388C9.14445 7.24332 10.3555 6.59598 11.674 6.33372C12.9925 6.07147 14.3591 6.20607 15.6011 6.72051C16.843 7.23495 17.9045 8.10612 18.6514 9.22386C19.3982 10.3416 19.7969 11.6557 19.7969 13C19.7949 14.802 19.0782 16.5297 17.8039 17.8039C16.5297 19.0782 14.802 19.7949 13 19.7969Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_235_16435">
        <rect width="18" height="18" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);

const ErrorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ErrorIcon;
